export const MortgagesPanel = 'MortgagesCard'
export const RefiSection = 'RefiSection'
export const ReverseMortgagesPanel = 'ReverseMortgagesCard'
export const HomeInsurancePanel = 'HomeInsuranceCard'
export const PmiPanel = 'PmiCard'
export const AirDnaPanel = 'AirDnaCard'
export const NoLoansPanel = 'NoLoansCard'
export const EquityPanel = 'EquityCard'
export const PurchasingPowerPanel = 'PurchasingPowerCard'
export const PrincipalPayments = 'PrincipalPayments'

export const Targets = {
  unverified_loans: MortgagesPanel,
  refi_30: RefiSection,
  refi_15: RefiSection,
  reverse: ReverseMortgagesPanel,
  home_insurance: HomeInsurancePanel,
  pmi: PmiPanel,
  rental: AirDnaPanel,
  principal_pay: PrincipalPayments,
  cash_out: EquityPanel,
  pp_trade: PurchasingPowerPanel,
  pp_investment: PurchasingPowerPanel,
  no_loans: NoLoansPanel
}
